import type { IContactInfo } from "@b2bportal/core-types";
import type {
  PassengerCount,
  PriceFreezeOffer,
} from "@b2bportal/price-freeze-api";
import type { CardPaymentContext, CartContext } from "@checkout/states";
import type { ParentState } from "@checkout/types";
import type { AirPriceFreezeStateEnum } from "./types";
import type { WalletPaymentContext } from "@/types";
import type { RewardsPaymentContext } from "@/types";

export interface FlightShopContext {
  fareId: string;
  passengerCount: PassengerCount;
  tripId: string;
}

export interface AirPriceFreezeOfferContext {
  flightsPriceFreezeOffers: PriceFreezeOffer[];
  selectedOfferId?: string;
}

export const initialAirPriceFreezeOfferContext: AirPriceFreezeOfferContext = {
  flightsPriceFreezeOffers: [],
};

export interface AirPriceFreezeMachineContext extends CartContext {
  // key name to match each context's selector
  [AirPriceFreezeStateEnum.walletPayment]: WalletPaymentContext;
  [ParentState.awardsPayment]: RewardsPaymentContext;
  [ParentState.cardPayment]: CardPaymentContext;

  [AirPriceFreezeStateEnum.flightShop]?: IContactInfo;
  [AirPriceFreezeStateEnum.contactInformation]?: IContactInfo;
  [AirPriceFreezeStateEnum.priceFreezeOffer]: AirPriceFreezeOfferContext;
}
